var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 36C28.665 36 36.5 28.165 36.5 18.5C36.5 8.83502 28.665 1 19 1C9.33502 1 1.5 8.83502 1.5 18.5C1.5 28.165 9.33502 36 19 36Z",
    stroke: "#FF4A4A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 9.66663H22.0002C20.8951 9.66663 19.8353 10.1056 19.0539 10.887C18.2725 11.6684 17.8335 12.7282 17.8335 13.8333V16.3333H15.3335V19.6666H17.8335V26.3333H21.1668V19.6666H23.6668L24.5002 16.3333H21.1668V13.8333C21.1668 13.6123 21.2546 13.4003 21.4109 13.244C21.5672 13.0878 21.7791 13 22.0002 13H24.5002V9.66663Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.330ffecac828317015e388b32d179c0b.svg";
export { ForwardRef as ReactComponent };